'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isDevelopment = exports.isProduction = exports.isEnvironment = undefined;

var _config = require('dynamic-data/config');

var isEnvironment = exports.isEnvironment = function isEnvironment() {
  for (var _len = arguments.length, envs = Array(_len), _key = 0; _key < _len; _key++) {
    envs[_key] = arguments[_key];
  }

  return envs.includes((0, _config.getConfig)().env);
};
var isProduction = exports.isProduction = function isProduction() {
  return isEnvironment('production');
};
var isDevelopment = exports.isDevelopment = function isDevelopment() {
  return isEnvironment('local', 'development');
};